import React, { useEffect, useState } from 'react';
import { styled } from 'styled-components';
import { formatNumber } from '@debbie/common/dist/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import THEME from '../theme.js';
import q from '@debbie/cortex/dist/query.js';
import { moneyCalculatorKey, useMoneyCalculator, } from '@debbie/cortex/dist/moneyCalculator/index.js';
const Money = (props) => {
    const loadable = useMoneyCalculator();
    const { count, items, sum } = h.hasData(loadable)
        ? loadable.data
        : { sum: 0, count: 0, items: {} };
    const [id] = useState(Math.random().toString());
    const { amount, currency } = props;
    const active = items[id];
    const remove = () => {
        q.mutateCache(moneyCalculatorKey, (current) => {
            let items = current?.items || {};
            if (items[id]) {
                delete items[id];
                return {
                    count: (current?.count || 1) - 1,
                    items: items,
                    sum: (current?.sum || 0) - amount,
                };
            }
            else {
                return {
                    count: current?.count || 0,
                    items: items || [],
                    sum: current?.sum || 0,
                };
            }
        });
    };
    const add = () => {
        q.mutateCache(moneyCalculatorKey, (current) => {
            if (!current) {
                return current;
            }
            current.items[id] = true;
            current.count += 1;
            current.sum += amount;
            return current;
        });
    };
    useEffect(() => {
        return () => {
            remove();
        };
    }, []);
    return (React.createElement(StyledMoney, { "data-tooltip-id": props['data-tooltip-id'], "data-tooltip-content": props['data-tooltip-content'], className: props.className, style: {
            opacity: active ? 0.5 : 1,
        }, onClick: () => {
            active ? remove() : add();
        }, _color: props.color, amount: props.amount },
        props.currency && props.prefixCurrency ? (React.createElement("small", null,
            props.currency,
            " ")) : null,
        React.createElement("span", { className: "select-all" }, formatNumber(props.amount)),
        props.currency && !props.prefixCurrency ? (React.createElement("small", null,
            " ",
            props.currency)) : null));
};
export default Money;
const StyledMoney = styled.span `
  cursor: pointer;
  user-select: none;
  ${(props) => props._color
    ? `color:  ${props.amount > 0
        ? THEME.SUCCESS
        : props.amount < 0
            ? THEME.DANGEROUS
            : ''}`
    : ''};

  small {
    opacity: 0.8;
    font-size: 0.7em;
  }
  .select-all {
    user-select: all;
  }
`;
//# sourceMappingURL=Money.js.map